module.exports = __webpack_public_path__ + "img/13.870ece0f.jpg";